module.exports = __webpack_public_path__ + "static/ebquad2-26e0d84ed137294612b50e4ec79710b0.jpg";